import { BaseError } from "./base-error.js";
export class NotFoundError extends BaseError {
    static code = 'NotFoundError';
    static statusCode = 404;
    constructor(message = 'Not Found', options = {}) {
        super(message, options);
    }
}
